import React, { Component } from "react"
import intl from "react-intl-universal"
import "./pay.css"
import { Table, Tabs, Steps, Button } from "antd"
import PayModel from "./PayModal"
import { getOrderById } from "../../../api/console/order/Order"
import { getPageQuery } from "../../../common/util/util"

const { TabPane } = Tabs
const { Step } = Steps


class Pay extends Component {

    payModalRef = React.createRef();

    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            orderDetail: {},
            initDone: false,
            orderId: getPageQuery().orderId,
        }
        this.showPayModal = this.showPayModal.bind(this)
        this.getOrderDetail = this.getOrderDetail.bind(this)

    }

    componentWillMount () {
        this.getOrderDetail()
    }


    getOrderDetail () {
        let orderId = this.state.orderId
        getOrderById(orderId).then((res) => {
            if (res.code === 0) {
                this.setState({
                    orderDetail: res.data.order,
                    initDone: true,
                })
            }
        }, (error) => {
            console.log("get response failed!")
        }
        )
    }

    /**
     * 账户信息
     */
    accountInfo () {
        return (
            <div>
                <div className="card-box">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="font-14-l22-w500">{intl.get('order.pay_info')}</div>
                        <div className="font-12-l20-w400-p6"></div>
                    </div>
                    <div className="font-14-l22-w400" style={{ marginTop: "16px" }}>
                        <div>
                            <span>{intl.get('order.pay_account1')}</span>
                            <span className="ml-80">{intl.get('order.account_name')}</span>
                        </div>
                        <div style={{ marginTop: "12px" }}>
                            <span>{intl.get('order.pay_account2')}</span>
                            <span className="ml-80">{intl.get('order.bank_address')}</span>
                        </div>
                        <div style={{ marginTop: "12px" }}>
                            <span>{intl.get('order.pay_account3')}</span>
                            <span className="ml-80">{intl.get('order.bank_account')}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    showPayModal () {
        this.payModalRef?.current?.showModal?.()
    }

    render () {
        const { initDone, orderDetail } = this.state
        const data = [
            orderDetail,
        ]

        let AccountInfo = this.accountInfo()

        // 订单号
        // 商品名称
        // 服务时长
        // 数量
        // 订单创建时间
        // 优惠金额
        // 应付金额
        const columns = [
            {
                title: intl.get('order.pay_col1'),
                dataIndex: 'orderNumber',
                key: 'orderNumber',
                // render: text => <a>{text}</a>,
            },
            {
                title: intl.get('order.pay_col2'),
                dataIndex: 'comboName',
                key: 'comboName',
            },
            {
                title: intl.get('order.pay_col3'),
                dataIndex: 'num',
                key: 'num',
            },
            {
                title: intl.get('order.pay_col4'),
                dataIndex: 'corpName',
                key: 'corpName',
            },
            {
                title: intl.get('order.pay_col5'),
                dataIndex: 'createdAt',
                key: 'createdAt',
            },
            {
                title: intl.get('order.pay_col6'),
                dataIndex: 'discount',
                key: 'discount',
            },
            {
                title: intl.get('order.pay_col7'),
                dataIndex: 'amount',
                key: 'amount',
            },

        ]


        return (
            initDone &&
            <div>
                <div className="welcome">
                    <div style={{ width: '100%', display: 'flex', justifyContent: "space-between", padding: '0 20px' }}>
                        <div className="font-20-l28">
                            {intl.get('order.pay_title')}
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div style={{ padding: '16px 12px' }}>
                        <div className="row" style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <div className="col-12" style={{ padding: '0 8px' }}>
                                <div className="bg-white">
                                    <div className="a-card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="font-16-l24">{intl.get('order.pay_title1')}</div>
                                            <div className="font-LH-14 color-black-85 font-weight-normal">

                                            </div>
                                        </div>
                                    </div>

                                    <div className="px-4 p-3">
                                        <Table columns={columns} dataSource={data} pagination={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        orderDetail.status < 2 &&
                        <div style={{ padding: '0px 12px' }}>
                            <div className="row" style={{ marginLeft: '0px', marginRight: '0px' }}>
                                <div className="col-12" style={{ padding: '0 8px' }}>
                                    <div className="bg-white">
                                        <div className="a-card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="font-16-l24">{intl.get('order.pay_type')}</div>
                                                <div className="font-LH-14 color-black-85 font-weight-normal">

                                                </div>
                                            </div>
                                        </div>

                                        <div className="px-4 pb-3">

                                            <Tabs defaultActiveKey="1">

                                                {/*充值反馈*/}
                                                {/*打款并提交汇款信息后，您可以前往订单管理页面查看进度*/}
                                                {/*<TabPane tab="线上支付" key="1">*/}
                                                {/*    Content of Tab Pane 1*/}
                                                {/*</TabPane>*/}
                                                <TabPane tab={intl.get('order.pay_tab2')} key="2" >
                                                    <Steps direction="vertical" current={-1} size="small">
                                                        <Step title={<div className="font-16-l24-w400">{intl.get('order.pay_desc1')}</div>} description={AccountInfo} />
                                                        <Step title={<div className="font-16-l24-w400">{intl.get('order.pay_desc2')}</div>} description={<Button style={{ margin: "20px 0 28px 0" }} type="primary" onClick={this.showPayModal}>{intl.get('order.pay_desc2')}</Button>} />
                                                        <Step title={<div className="font-16-l24-w400">{intl.get('order.pay_desc3')}</div>} description={<div style={{ marginTop: "8px" }}>{intl.getHTML('order.pay_desc4')}</div>} />
                                                    </Steps>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>

                <PayModel ref={this.payModalRef} detail={this.state.orderDetail} callback={this.getOrderDetail}></PayModel>

            </div>
        )
    }
}

export default Pay
